import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=51d1c51e&scoped=true"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"
import style0 from "./Achievements.vue?vue&type=style&index=0&id=51d1c51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d1c51e",
  null
  
)

export default component.exports